import {isAxiosError} from 'axios';

/**
 * Saves a file the API streamed back (e.g. a CSV export requested with
 * `responseType: 'blob'`) through a temporary object URL, the same
 * anchor-click approach AppReleases' DownloadButton uses for a direct link.
 */
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * A request made with `responseType: 'blob'` gets its error body back as a
 * Blob too, so `response.data.message` (what the Merchants error readers look
 * for) would be missing. Parses a JSON error body back into an object in
 * place, so a failed download surfaces the server's message like any other
 * failed request. Anything else is returned untouched.
 */
export const parseBlobErrorBody = async (error: unknown): Promise<unknown> => {
  const data: unknown = isAxiosError(error) ? error.response?.data : undefined;
  if (!(data instanceof Blob) || !data.type.includes('application/json')) {
    return error;
  }
  try {
    (error as {response: {data: unknown}}).response.data = JSON.parse(
      await data.text(),
    );
  } catch {
    // Not valid JSON after all; leave the Blob for the caller's fallback.
  }
  return error;
};
